

function fourIItemCarousel(){
    const fourIItemCarousel = document.querySelector('.four-item-carousel')
    if( fourIItemCarousel != null )
        var testimonialcarousel = new Swiper('.four-item-carousel', {
            slidesPerView: 4,
            spaceBetween: 30,
            mousewheel: false,
            speed: 1400,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: '.four-item-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.prev-btn',
                prevEl: '.next-btn',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                800: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                600: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 30
                }
            }
        });
}

window.addEventListener('DOMContentLoaded', (event) => {
    if(document.querySelector('.animation_text_word') != null){
        let animateSpanText = document.querySelector('.animation_text_word').dataset.info.split(',')
        var options = {
            strings: animateSpanText,
            showCursor: false,
            loop: true,
            typeSpeed: 110
          };
        var typed = new Typed('.animation_text_word', options);
    }
    
    const singleItemCarousel = document.querySelector('.single-item-carousel')
    if( singleItemCarousel != null )
        var testimonialcarousel = new Swiper('.single-item-carousel', {
            slidesPerView: 1,
            spaceBetween: 30,
            mousewheel: false,
            speed: 1400,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: '.single-item-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.prev-btn',
                prevEl: '.next-btn',
            },
            breakpoints: {
            1024: {
	                slidesPerView: 1,
	                spaceBetween: 30
	            },
	            800: {
	                slidesPerView: 1,
	                spaceBetween: 30
	            },
	            600: {
	                slidesPerView: 1,
	                spaceBetween: 30
	            },
	            480: {
	                slidesPerView: 1,
	                spaceBetween: 30
	            },
	            320: {
	                slidesPerView: 1,
	                spaceBetween: 30
	            }
	        }
        });
	
    
    const eightItemCarousel = document.querySelector('.eight-item-carousel')
    if( eightItemCarousel != null )
        var testimonialcarousel = new Swiper('.eight-item-carousel', {
            slidesPerView: 8,
            spaceBetween: 30,
            mousewheel: true,
            speed: 1400,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: '.eight-item-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.prev-btn',
                prevEl: '.next-btn',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 6,
                    spaceBetween: 30
                },
                800: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                600: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                480: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 30
                }
            }
        })
    const bannerSlider = document.querySelector('.banner-carousel')
    if( bannerSlider != null ){
        if(bannerSlider.classList.contains('no-slider') == false ) {
            var testimonialsTwoThumbCarousel = new Swiper('.banner-carousel', {
                slidesPerView: 1,
                spaceBetween: 0,
                mousewheel: false,
                speed: 1400,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                pagination: {
                    el: '.banner-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.banner-slider-button-next',
                    prevEl: '.banner-slider-button-prev',
                }
            })
        }
    }

    const reviewSliderOne = document.querySelector('.testimonial-carousel')
    if( reviewSliderOne  != null ){
        if(reviewSliderOne.classList.contains('no-slider') == false ) {
            var testimonialcarousel = new Swiper('.testimonial-carousel', {
                slidesPerView: 2,
                spaceBetween: 70,
                mousewheel: false,
                speed: 1400,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.prev-btn',
                    prevEl: '.next-btn',
                },
                breakpoints: {
                1024: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    800: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    700: {
                        slidesPerView: 1,
                        spaceBetween: 30
                    },
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 30
                    },
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 30
                    }
                }
            });
            
        }
    }

    const checkNoSlider= document.querySelector('.four-item-carousel')
    if( checkNoSlider  != null ){
        if(checkNoSlider.classList.contains('no-slider') == false ) {
            fourIItemCarousel()
        }
    }
    
    
});




const filterActive = document.querySelector('.fillter-action-optn-btn')
if(filterActive != null)
    filterActive.addEventListener('click', e => {
        e.preventDefault()
        filterActive.classList.toggle('active')
        document.querySelector('.facets__wrapper').classList.toggle('active')
        document.querySelector('.active-facets-column').classList.toggle('active')
    })
const rawHeader = document.querySelector('.raw-header-me')
if(rawHeader != null){
    document.body.classList.add('raw-header-bg')
}



// Back to top
    const backToTopBtn = document.querySelector(".back-to-top");
    const isSticky = document.querySelector(".main-header.scroll-up");

    if (backToTopBtn != null) {
        const scrollTrigger = 400;
        const backToTop = () => {
            backToTopBtn.classList.toggle("show", window.scrollY > scrollTrigger);
        };

        backToTop();
        window.addEventListener("scroll", backToTop);
        backToTopBtn.addEventListener("click", (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });

            if(isSticky){
                isSticky.classList.remove("sticky");
                isSticky.classList.add("remove-sticky");

                setTimeout(() => {
                    isSticky.classList.remove("remove-sticky");
                }, 1000);
            }
        });
    }


    const menuOuter = document.querySelector('.menu-outer')
    const menuBackdrop = document.querySelector('.menu-backdrop')
    const navLogo = document.querySelector('.nav-logo')
    const mobileMenu = document.querySelector('.mobile-menu')
    const closeBtn = document.querySelector('.close-btn')
    const menuLastBtn = document.querySelector('.this-is-menu-hidden')

    if (mobileMenu && closeBtn && menuLastBtn) {
        mobileMenu.addEventListener('keydown', function(event) {
            if (event.key === 'Tab') {
                if (document.activeElement === menuLastBtn) {
                    closeBtn.focus();
                }
            }
        });
    }

    class AnnouncementBar extends HTMLElement {
        constructor() {
            super()
            this.init()
        }
        get items() {
            return this._items=this._items||Array.from(this.children)
        }
        get watchCSS() {
            return this.hasAttribute("watch-css")
        }
        get initialIndex() {
            return parseInt(this.getAttribute("initial-index")||0)
        }
        init() {
            if (this.items.length > 1) {
                this.carousel = new Flickity(this, {
                    watchCSS: this.watchCSS,
                    // fade: true,
                    prevNextButtons: true,
                    adaptiveHeight: false,
                    wrapAround: true,
                    initialIndex: this.initialIndex,
                    pageDots: false
                });
        
                this.addEventListener("control:select", event => this.select(event.detail.index));
                this.carousel.on("change", this.onChange.bind(this));
                Shopify.designMode && this.addEventListener("shopify:block:select", event => this.carousel.resize())
                // window.addEventListener('resize', () => {
                //     this.carousel.resize();
                //     console.log('resize');
                // });
                // const mutationObserver = new MutationObserver(() => {
                //     this.carousel.resize();
                //     console.log('mutationObserver');
                // });
                // mutationObserver.observe(this, { childList: true, subtree: true });
                setTimeout(() => {
                    this.select(this.initialIndex, true);
                }, 100);
            }
        }

        disconnectedCallback() {
            this.carousel&&this.carousel.destroy()
        }
        select(index=0,immediate=!1) {
            if(!immediate) {
                const {
                    selectedIndex,slides
                }
                =this.carousel;
                immediate=Math.abs(index-selectedIndex)>3,index===0&&selectedIndex===slides.length-1&&(immediate=!1),index===slides.length-1&&selectedIndex===0&&(immediate=!1)
            }
            this.carousel.select(index,!1,immediate)
        }
        onChange(index) {
            this.dispatchEvent(new CustomEvent("carousel:change", {
                bubbles:!0,detail: {
                    index
                }
            }))
        }
    }
    customElements.define("announcement-bar",AnnouncementBar);
